var _defs, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNightrain(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #66afeb;\n      }\n\n      .cls-2 {\n        fill: #ffbb19;\n      }\n\n      .cls-3 {\n        fill: #9ec5fb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.47,2.67c.57,.9,.9,1.97,.9,3.12,0,3.25-2.63,5.88-5.88,5.88-1.67,0-3.17-.7-4.24-1.81,.6,2.99,3.24,5.24,6.41,5.24,3.61,0,6.54-2.93,6.54-6.54,0-2.6-1.53-4.84-3.73-5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.69,15.91c-.29,0-.56,.05-.83,.13,0-.04,0-.08,0-.13,0-3.37-2.73-6.1-6.1-6.1-2.84,0-5.23,1.95-5.9,4.58-.23-.04-.46-.07-.7-.07-2.12,0-3.84,1.72-3.84,3.84,0,1.91,1.4,3.6,3.23,3.9h.03s7.21,0,7.21,0c0,0,0,0,0,0s0,0,0,0h6.55c.15,0,.27,0,.35,0,1.69,0,3.04-1.4,3.04-3.09s-1.37-3.06-3.06-3.06Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.61,27.63h0c-.52-.19-.78-.77-.59-1.29l1.37-3.03c.19-.52,.77-.78,1.29-.59h0c.52,.19,.78,.77,.59,1.29l-1.37,3.03c-.19,.52-.77,.78-1.29,.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.32,28.92h0c-.52-.19-.78-.77-.59-1.29l1.37-3.03c.19-.52,.77-.78,1.29-.59h0c.52,.19,.78,.77,.59,1.29l-1.37,3.03c-.19,.52-.77,.78-1.29,.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightrain);
export default __webpack_public_path__ + "static/media/nightrain.fd232975130a0942507d79f4c5dc646d.svg";
export { ForwardRef as ReactComponent };